import StopStatusLog from './component';

export default StopStatusLog;
